import { StyleRules } from '@material-ui/core/styles';
import { TableRowClassKey } from '@material-ui/core/TableRow';

import { core as theme } from '../styles/core';

export const MuiTableRow: Partial<StyleRules<TableRowClassKey>> = {
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.grey.A100,
    },
    '&:hover': {
      backgroundColor: theme.palette.grey.A200,
    },
    '& > th': {
      fontWeight: 500,
    },
  },
};
